export const ROLE_LABELS = {
  super_admin: "Super Admin",
  analyst: "Analyst",
  qa_reviewer: "QA Reviewer",
  field_agent: "Field Agent",
  org_admin: "Org Admin",
  requester: "Requester",
  viewer: "Viewer",
  consumer: "Personal account",
};

export const STAFF_ROLES = ["super_admin", "analyst", "qa_reviewer", "field_agent"];
export const ORG_ROLES = ["org_admin", "requester", "viewer"];

export const roleOf = (u) => u?.platform_role || u?.org_role || (u?.account_type === "consumer" ? "consumer" : undefined);
export const homePathFor = (u) => {
  if (u?.platform_role === "super_admin") return "/admin";
  if (u?.account_type === "consumer") return "/me";
  if (u?.platform_role === "field_agent") return "/field";
  if (["analyst", "qa_reviewer"].includes(u?.platform_role)) return "/ops";
  return "/console";
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—";
